<template>
  <a-table rowKey="id" :data-source="list" :pagination="pagination" :loading="listLoading" @change="handleTableChange">
    <a-table-column
      key="name"
      title="访客姓名"
      data-index="name"
      align="center"
      :ellipsis="true"
      width="9%"
    ></a-table-column>
    <a-table-column
      key="post"
      title="职务"
      data-index="post"
      align="center"
      :ellipsis="true"
      width="8%"
    ></a-table-column>
    <a-table-column
      key="cellphone"
      title="联系电话"
      data-index="cellphone"
      align="center"
      :ellipsis="true"
      width="8%"
    ></a-table-column>
    <a-table-column
      key="mechanismName"
      title="所在机构"
      data-index="mechanismName"
      align="center"
      :ellipsis="true"
      width="8%"
    ></a-table-column>
    <a-table-column
      key="area"
      title="所处地域"
      data-index="area"
      align="center"
      :ellipsis="true"
      width="14%"
    ></a-table-column>
    <a-table-column
      key="problem"
      title="问题需求"
      data-index="problem"
      align="center"
      :ellipsis="true"
      width="14%"
    ></a-table-column>
    <a-table-column key="actions" title="操作" align="center" :ellipsis="true" width="8%">
      <template slot-scope="record">
        <a-button type="link" v-if="$auth('visitor_detail')" size="small" @click="handleDetail(record)">
          <a-icon type="eye" />详情</a-button
        >
      </template>
    </a-table-column>
  </a-table>
</template>

<script>
import * as experienceApi from '@/api/experience'

export default {
  data: function () {
    return {
      query: {},
      pagination: {},
      listLoading: false,
      list: [],
    }
  },
  activated() {
    const { ready, getData } = this
    if (ready) {
      getData()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.ready = true
    })
  },
  methods: {
    initData(query = {}) {
      const { initPagination, getData } = this
      this.query = query
      this.pagination = initPagination()
      return getData()
    },
    getData() {
      const {
        pagination: { current: pageIndex, pageSize },
        query,
      } = this

      this.listLoading = true

      return experienceApi
        .getList({ ...query, pageIndex, pageSize })
        .then((res) => {
          const { list, totalItems: total } = res.data

          this.list = list
          this.pagination.total = total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    initPagination() {
      return {
        current: 1,
        pageSize: 10,
        showTotal: (total) => {
          const h = this.$createElement
          const {
            pagination: { pageSize },
          } = this

          return h('div', {}, [
            h('span', '共 '),
            h('span', { class: 'primary-color' }, pageSize ? Math.ceil(total / pageSize) : Math.ceil(total / 10)),
            h('span', ' 页'),
            h('span', ' / '),
            h('span', { class: 'primary-color' }, total),
            h('span', ' 条数据'),
          ])
        },
        showSizeChanger: true,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100'],
      }
    },
    handleTableChange(pagination, filters, sorter) {
      const { getData } = this

      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize

      getData()
    },
    handleDetail(record) {
      this.$emit('handleDetail', record)
    },
  },
}
</script>

<style lang="less" scoped>
.desc {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ant-divider,
.ant-divider-vertical {
  margin: 0 16px;
}
/deep/ .ant-table-pagination.ant-pagination {
  margin: 24px;
}
@media (max-width: 1919px) {
  /deep/ .ant-btn {
    font-size: 12px;
  }
}
</style>
